module.exports = __webpack_public_path__ + "static/media/Arcade_4611.2adf4d98.jpg";